import VStack from "shared/components/layout/stack/VStack";
import RetainersDashboardOverviewData from "features/projects/retainers-dashboard/single/RetainersDashboardOverviewData";
import RetainersDashboardOverviewBudget from "features/projects/retainers-dashboard/single/RetainersDashboardOverviewBudget";
import RetainersDashboardOverviewProject from "features/projects/retainers-dashboard/single/RetainersDashboardOverviewProject";

const RetainersDashboardOverview = () => {
    return (
        <VStack style={{ gap: "40px" }}>
            <RetainersDashboardOverviewData />
            <div>
                <RetainersDashboardOverviewBudget />
            </div>
            <div>
                <RetainersDashboardOverviewProject />
            </div>
        </VStack>
    );
};

export default RetainersDashboardOverview;
